export const EXPERTISE_PAGES = {
    "inteligencia-artificial": {
        eyebrow: "Inteligencia artificial y datos",
        title: "IA aplicada a decisiones y procesos reales",
        lead:
            "Diseñamos soluciones de inteligencia artificial a partir del problema, los datos disponibles y el nivel de riesgo del proceso. El objetivo no es añadir IA por moda, sino convertirla en una capacidad útil, medible y gobernable.",
        definition:
            "EMMPIEZA integra modelos de lenguaje, recuperación de información, analítica y software para crear herramientas que consultan fuentes, automatizan tareas y apoyan decisiones con trazabilidad.",
        capabilities: [
            ["IA generativa y RAG", "Asistentes conectados con documentos, bases de conocimiento y fuentes controladas."],
            ["Analítica y predicción", "Preparación de datos, tableros, patrones y modelos para anticipar escenarios."],
            ["Automatización inteligente", "Flujos que combinan modelos, reglas, APIs, validaciones y revisión humana."],
            ["Gobernanza de IA", "Controles para privacidad, calidad, alucinaciones, seguridad y seguimiento."],
        ],
        process: [
            "Definimos el problema, los usuarios y la decisión que debe mejorar.",
            "Evaluamos datos, fuentes, restricciones y riesgos.",
            "Construimos y medimos un prototipo con criterios verificables.",
            "Integramos la solución y dejamos controles de operación y mejora.",
        ],
        faq: [
            ["¿EMMPIEZA desarrolla modelos propios?", "Seleccionamos la arquitectura adecuada para cada caso: modelos existentes, RAG, modelos especializados o componentes predictivos propios."],
            ["¿Puede conectarse la IA con información privada?", "Sí, diseñando permisos, aislamiento, trazabilidad y políticas de retención acordes con el tipo de información."],
            ["¿Cómo se reducen las respuestas incorrectas?", "Con fuentes delimitadas, evaluación, citas, reglas de abstención, monitoreo y revisión humana cuando el riesgo lo exige."],
        ],
    },
    "software-y-aplicaciones": {
        eyebrow: "Software web y móvil",
        title: "Productos digitales construidos para operar y evolucionar",
        lead:
            "Convertimos necesidades de negocio en aplicaciones web y móviles mantenibles, seguras y medibles. Cubrimos definición funcional, arquitectura, desarrollo, despliegue y evolución.",
        definition:
            "El software de EMMPIEZA integra interfaces claras, servicios backend, datos, autenticación e infraestructura para resolver un flujo completo, no solamente una pantalla.",
        capabilities: [
            ["Aplicaciones web", "Plataformas empresariales, portales, paneles, comercio electrónico y herramientas internas."],
            ["Aplicaciones móviles", "Productos Android e iOS con nube, notificaciones, mapas, pagos e integraciones."],
            ["Backend y APIs", "Servicios, autenticación, bases de datos e integración con plataformas de terceros."],
            ["Calidad y operación", "Pruebas, observabilidad, despliegue y prácticas de desarrollo seguro."],
        ],
        process: [
            "Entendemos el proceso, los usuarios y el resultado de negocio.",
            "Priorizamos un alcance entregable y una arquitectura sostenible.",
            "Diseñamos, desarrollamos y validamos en ciclos cortos.",
            "Desplegamos con métricas, soporte y una ruta de evolución.",
        ],
        faq: [
            ["¿Trabajan productos nuevos o sistemas existentes?", "Ambos. Podemos construir un MVP, ampliar una plataforma o integrar componentes nuevos con sistemas existentes."],
            ["¿Desarrollan para Android y iOS?", "Sí. Elegimos tecnología nativa o multiplataforma según experiencia, integraciones, presupuesto y mantenimiento."],
            ["¿El proyecto incluye backend?", "Cuando el producto lo necesita, incluimos APIs, base de datos, autenticación, panel administrativo e infraestructura."],
        ],
    },
    ciberseguridad: {
        eyebrow: "Ciberseguridad",
        title: "Seguridad ofensiva traducida en correcciones concretas",
        lead:
            "Evaluamos aplicaciones y superficies digitales con mentalidad ofensiva y convertimos los hallazgos en prioridades claras para equipos técnicos y responsables de negocio.",
        definition:
            "EMMPIEZA combina pentesting, revisión de código y conocimiento de desarrollo para encontrar fallos explotables y acompañar una remediación que no rompa el producto.",
        capabilities: [
            ["Pentesting web y API", "Pruebas controladas de autenticación, autorización, entradas, sesiones y lógica de negocio."],
            ["Revisión de código", "Análisis de patrones inseguros, dependencias, secretos y controles críticos."],
            ["Hardening", "Reducción de superficie de ataque y fortalecimiento de configuración e infraestructura."],
            ["Desarrollo seguro", "Controles y prácticas de seguridad integrados en arquitectura, código y despliegue."],
        ],
        process: [
            "Acordamos alcance, reglas de prueba y activos autorizados.",
            "Modelamos la superficie y validamos vulnerabilidades con evidencia.",
            "Priorizamos por impacto y probabilidad, no solo por etiqueta técnica.",
            "Entregamos recomendaciones y verificamos las correcciones acordadas.",
        ],
        faq: [
            ["¿Qué entrega un pentest?", "Un informe con evidencia reproducible, impacto, prioridad y recomendaciones técnicas para cada hallazgo validado."],
            ["¿Las pruebas pueden afectar producción?", "El alcance y las técnicas se acuerdan previamente; se aplican límites para reducir riesgo y se coordinan las pruebas sensibles."],
            ["¿También ayudan a corregir?", "Sí. Podemos explicar, revisar o implementar remediaciones dentro del alcance acordado."],
        ],
    },
};

export const AVIATION_PAGE = {
    eyebrow: "IA + aviación + seguridad operacional",
    title: "Tecnología para apoyar decisiones en entornos aeronáuticos",
    lead:
        "EMMPIEZA conecta inteligencia artificial y analítica de datos con experiencia operacional aeronáutica. Diseñamos casos de uso que conservan trazabilidad, supervisión humana y respeto por el contexto de un sector crítico.",
    definition:
        "La IA en aviación puede ayudar a organizar información, identificar tendencias y reducir carga de búsqueda. No reemplaza por defecto el criterio profesional ni los procesos de seguridad: debe integrarse con límites, fuentes y validación.",
    capabilities: [
        ["Información operacional", "Consulta asistida de manuales, procedimientos, reportes y documentación con fuentes identificables."],
        ["Analítica de seguridad", "Organización de datos y detección de tendencias para apoyar el análisis de peligros y riesgos."],
        ["Factores humanos", "Herramientas que consideran carga de trabajo, contexto, supervisión y límites de automatización."],
        ["Adopción responsable", "Evaluación de casos de uso, gobernanza de datos, validación y controles para un sector crítico."],
    ],
    process: [
        "Delimitamos la necesidad operacional y las decisiones involucradas.",
        "Identificamos fuentes oficiales, responsables, restricciones y riesgos.",
        "Probamos utilidad, exactitud, trazabilidad y escenarios de fallo.",
        "Definimos supervisión humana, monitoreo y criterios de uso seguro.",
    ],
    faq: [
        ["¿La IA puede tomar decisiones operacionales por sí sola?", "Depende del caso, el riesgo y el marco aplicable. Nuestro enfoque inicial prioriza apoyo a la decisión, trazabilidad y supervisión humana."],
        ["¿Qué información puede analizar?", "Manuales, procedimientos, reportes y datos estructurados cuando existen permisos, calidad suficiente y un propósito claramente delimitado."],
        ["¿Cómo se gestiona una respuesta incorrecta?", "Con fuentes visibles, reglas de abstención, evaluación sistemática, límites de uso y escalamiento a personal competente."],
    ],
    authorityLinks: [
        ["IA para sistemas de gestión de seguridad operacional", "/conocimiento/ia-sms-seguridad-operacional"],
        ["RAG para documentación aeronáutica", "/conocimiento/rag-documentacion-aeronautica"],
        ["IA para reportes de seguridad operacional", "/conocimiento/ia-reportes-seguridad-operacional"],
        ["Factores humanos e inteligencia artificial", "/conocimiento/factores-humanos-inteligencia-artificial"],
        ["Ciberseguridad aeronáutica", "/conocimiento/ciberseguridad-aeronautica"],
        ["IA para operaciones críticas", "/conocimiento/ia-operaciones-criticas"],
    ],
    sources: [
        ["ICAO — Safety Management", "https://www.icao.int/safety-management"],
        ["EASA — Artificial Intelligence", "https://www.easa.europa.eu/en/domains/research-innovation/ai"],
        ["FAA — Roadmap for AI Safety Assurance", "https://www.faa.gov/aircraft/air_cert/step/roadmap_for_AI_safety_assurance"],
    ],
};
